import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';
import { hexToRgbA } from 'util/styleUtil';
import skins from 'defaults/skins'

const getSkin = (theme) => {
	const skin = theme.globalProfiles.palette;
	const myTypography = typography(theme);

	return StyleSheet.create({
		mvpContainer: {
			
		},
		mvpText: {
			...myTypography.body2,
			lineHeight: 1,
			color: skin.white,
			fontWeight: 600,
			fontSize: '0.75em'
		},
		mvpValue: {
			...myTypography.body1,
			fontFamily: skins.fontFamily.timerFamily,
			lineHeight: 1,
			fontSize: '1em',
			fontWeight: 700,
			color: skin.white,
		},
		mvpProgressBarContainer: {
			background: hexToRgbA('#EAEAEA', 0.3)
		},
		mvpProgressBar: {
			background: skin.white
		}
	});
}

export default getSkin;